// Build lookup table mapping tuple keys to tree node instances
export default function(tree, key, filter) {
  var map = {};
  tree.each(function(node) {
    var t = node.data;
    if (filter(t)) map[key(t)] = node;
  });
  tree.lookup = map;
  return tree;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-hierarchy/src/lookup.js
// module id = 337
// module chunks = 0